module.exports = __webpack_public_path__ + "static/media/le-malin-win.f9751fb1.png";